import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { Button, Form, FormGroup, Label, FormFeedback } from 'reactstrap';

import StateLookup from 'components/StateLookup';
import { renderField } from 'core/utils/formik';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

const handleStateLookupChange = (field, form, state) => {
  state = state || {};
  form.setFieldValue(field.name, state.id);
}

const renderStateLookup = ({ field, form }) => {
  const { name } = field;
  const { errors, touched } = form;
  return (
    <FormGroup color={(touched[name] && errors[name]) ? 'danger' : ''}>
      <Label for="state_id">Select State</Label>
      <StateLookup
        onChange={state => handleStateLookupChange(field, form, state)}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
      {touched[name] && errors[name] && <FormFeedback>{errors[name]}</FormFeedback>}
    </FormGroup>
  )
};

const StateReportForm = ({ handleSubmit, isSubmitting, isValid }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        name="state_id"
        component={renderStateLookup}
      />

      <Field
        type="date"
        dateFormat="m/d/Y"
        name="start_date"
        label="Start Date"
        component={renderField}
      />

      <Field
        type="date"
        dateFormat="m/d/Y"
        name="end_date"
        label="End Date"
        component={renderField}
      />

      <Button
        type="submit"
        color="primary"
        disabled={!isValid || isSubmitting}
      >
        Generate
      </Button>
    </Form>
  );
};

StateReportForm.propTypes = propTypes;

export default withFormik({
  mapPropsToValues: () => ({
    state_id: '',
    start_date: moment().subtract(1, 'month').toDate(),
    end_date: new Date(),
  }),
  validationSchema: Yup.object().shape({
    state_id: Yup.string().required('Required'),
    start_date: Yup.string().required('Required'),
    end_date: Yup.string().required('Required'),
  }),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
})(StateReportForm);



// WEBPACK FOOTER //
// ./src/features/reports/StateReportForm.js